<form #cashboxForm="ngForm" (ngSubmit)="openCashbox()">
    <div class="modal-content">
        <h5 class="modal-title" *ngIf="!this.cashboxService.openedFromScFinish">Abrir caja</h5>
        <h5 class="modal-title" *ngIf="this.cashboxService.openedFromScFinish">¿Deseas abrir caja antes de realizar tu primera venta del día?</h5>
        <div class="modal-footer my-1"></div>

        <div class="row">
            <div class="form-group d-flex align-items-center gap-2">
                <label for="cajaAmount" class="box-text mr-2"><strong>Monto inicial (USD)</strong></label>
                <div class="input-group custom-width">
                    <input
                        class="form-control box-input-span"
                        type="number"
                        min="0"
                        required
                        [(ngModel)]="cajaAmount"
                        name="cajaAmount"
                        #amountInput="ngModel"
                        pattern="^\d{1,10}(\.\d{1,2})?$"
                        max="9999999999.99"
                        step="0.01"
                        (input)="validateAmount($event)"
                    />
                    <span class="currency">$</span>
                </div>
            </div>
        </div>
        <div *ngIf="(amountInput.invalid && (amountInput.dirty || amountInput.touched)) || (insufficientFunds() && cajaAmount > 0)" class="error-messages mt-1">
            <small class="text-danger" *ngIf="amountInput.errors?.['required']">Campo requerido </small>
            <small class="text-danger" *ngIf="amountInput.errors?.['min']">Valor mínimo: 0 </small>
            <small class="text-danger" *ngIf="amountInput.errors?.['pattern']">Formato inválido. Máximo 10 dígitos y 2 decimales </small>
            <small class="text-danger" *ngIf="insufficientFunds() && cajaAmount > 0">Fondos insuficientes en la cuenta Caja Efectivo </small>
        </div>
        <div *ngIf="cajaAmount === 0" class="warning-message mt-1">
            <small class="text-warning"><i class="fa fa-exclamation-triangle mr-1"></i> <strong>Está abriendo la caja con monto inicial de $0</strong></small>
        </div>

        <div class="modal-footer d-flex align-items-center justify-content-center gap-2">
            <button class="btn btn-cancel" (click)="closeModal()" type="button">Cancelar</button>
            <button
                class="btn btn-open-modal"
                (click)="openCashbox()"
                type="button"
                [disabled]="!cashboxForm.valid || insufficientFunds() || !(this.userService.user$ | async)?.permissions?.POS?.includes('open-cashbox')"
            >
                Abrir caja
            </button>
        </div>
    </div>
</form>
